import * as React from 'react'
import { ReactElement } from 'react'
import { Route, Switch } from 'react-router'
import PartyOverview from './Party/PartyOverview'
import AddLegalPerson from './Party/AddLegalPerson'
import EditLegalPerson from './Party/EditLegalPerson'
import AddNaturalPerson from './Party/AddNaturalPerson'
import EditNaturalPerson from './Party/EditNaturalPerson'
import FilePartyOverview, { FilePartyOverviewProps } from './Party/FilePartyOverview'

type Props = {
    global?: boolean
    prefix?: string
    overviewProps?: FilePartyOverviewProps
}

export default function Parties(props: Props): ReactElement {
    const prefix: string = props.prefix || ''

    return (
        <Switch>
            <Route exact path="/party" component={PartyOverview} />
            <Route path={`${prefix}/party/natural/add`} component={AddNaturalPerson} />
            <Route path={`${prefix}/party/natural/:id/edit`} component={EditNaturalPerson} />
            <Route path={`${prefix}/party/legal/add`} component={AddLegalPerson} />
            <Route path={`${prefix}/party/legal/:id/edit`} component={EditLegalPerson} />
            <Route path="/file/:fileId/party" render={() => <FilePartyOverview {...props.overviewProps} />} />
        </Switch>
    )
}
